import React from "react"

import SectionDivider from "./section-divider"
import { TitleBlock } from "./title-divider.style"

const TitleDivider = ({ text, backgroundColor }) => {
  return (
    <>
      <SectionDivider />
      <TitleBlock backgroundColor={backgroundColor}>{text}</TitleBlock>
      <SectionDivider flip />
    </>
  )
}

export default TitleDivider
